'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import authService from '@/lib/services/auth';
import type { RegisterData } from '@/lib/services/auth/types';

export function useRegistration() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();

  const register = async (data: RegisterData) => {
    setLoading(true);
    setError(null);

    try {
      console.log('Iniciando chamada de registro...');

      const result = await authService.register(data);

      console.log('Resultado do registro:', result);

      if (!result.success) {
        console.log('Erro no registro:', result.error);
        setError(result.error || "Erro ao criar conta");
        return false;
      }

      // Redirecionar para o dashboard usando window.location
      // para garantir um refresh completo da página
      if (result.success && !result.error) {
        window.location.href = '/dashboard';
      }

      return true;
    } catch (error) {
      console.error('Erro no registro (catch):', error);
      setError(error instanceof Error ? error.message : 'Erro ao criar conta');
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    register,
    loading,
    error,
    setError
  };
}